// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1F_AV","notes":"Notes_notes__2FLp8"};